import React from "react";
import PropTypes from "prop-types";

import Fieldset from "lib/components/Fieldset/Fieldset";

import { DynamicField } from "./FormInputs";

const CouponForm = ({
  membership,
  handleValueChange,
  errors,
}) => {
  return (
    <div>
      <div className="member_fields">
        <Fieldset legend="Discount Code">
          <DynamicField
            name="coupon_code"
            label="Enter a valid Discount Code, if you have one"
            value={membership["coupon_code"]}
            // readOnly={true}
            error={errors["coupon_code"] ? errors["coupon_code"][0] : ""}
            isRequired={false}
            handleOnChange={(val) => handleValueChange("coupon_code", val)}
          />
        </Fieldset>
      </div>
    </div>
  );
}

CouponForm.propTypes = {
  membership: PropTypes.object.isRequired
};

export default CouponForm;
